module.exports = __webpack_public_path__ + "static/music-6cd7d50d5c55f44970cd46040777bf92.mp3";